import type { FaireProductEntity } from "../../entity_types/product";

export const p_tynr923px8: FaireProductEntity = {
  token: "p_tynr923px8",
  type: "product",
  name: 'Tight Optic All Purpose-7"H(12oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/9750104ac54e4502d1e41241fb467b1061b044e158d9b218cd2e9cddc26f46c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c20368d71f1599692250267de424264a5aaad26334b630624ea313dc798ae4f.jpeg",
    "https://cdn.faire.com/fastly/10fb1b05692fe60764bafd33207ee610ff84b6ccac33dc2abc2cc62bc896be01.jpeg",
    "https://cdn.faire.com/fastly/9c7b0226b2f8ce08cb8da0057c3d4d8517cc52cfbfebd50c87fa966801771e39.jpeg",
  ],
  priceDollars: 8,
  description:
    "Give your dinner party the glassware it deserves with this tight optic all-purpose glass. Crafted out of optic glass with intricate line detailing, this glass is sure to be the star of any entertaining occasion. Hand wash only. Also available in other styles.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:15.859Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
